export default "__VITE_ASSET__DkevNPvt__"